import React, { useEffect, useState } from 'react';
import AdminTable from 'common/AdminTable';
import { useParams } from 'react-router-dom';
import { getRequest } from 'apis/ApiInstence';

const WalletCustomerList = () => {
    const { id } = useParams();
    const [cartData, setCartData] = useState([])
    const [refresh, setRefresh] = useState(false);

    const loadInitialData = async () => {
        const res = await getRequest(`order/${id}`);
        if (res?.status) {
            setCartData(res)
        } else {
            toast('Failed to update QR!')
        }
    };
    useEffect(() => {
        loadInitialData()
    }, [refresh])

    const handleRefresh = () => {
        setRefresh(!refresh)
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'Name',
            accessor: 'customer.name',
            Cell: ({ row }) => (
                <>
                    {row.original.customer.name.toUpperCase()}</>
            )
        },

        {
            Header: 'Mobile',
            accessor: 'customer.mobile',
        },
        {
            Header: 'Balance',
            accessor: 'customer.wallet',
        },

        {
            Header: 'Type',
            accessor: 'orderType',
            Cell: ({ row }) => (
                <>
                    {row.original.orderType == 'add' ? <span className='badge badge-primary p-2 text-white'> {row.original.orderType.toUpperCase()}</span> : row.original.orderType == 'win' ? <span className='badge badge-success p-2 text-white'> {row.original.orderType.toUpperCase()}</span> : <span className='badge badge-danger p-2 text-white'> {row.original.orderType.toUpperCase()}</span>}
                </>
            )
        },
        {
            Header: 'Amount',
            accessor: 'total_amount'
        },
        {
            Header: 'Date',
            accessor: 'createdAt'
        },

    ];

    return (
        <>
            <div className='container-fluid mt-5'>
                <div className='mainheadig mx-4 d-flex'>
                    <h4 className="text-white font-weight-bold">Wallet History</h4>
                    <button className="ml-auto btn btn-primary mr-4" onClick={() => handleRefresh()}><i className="fa fa-refresh" aria-hidden="true"></i></button>
            </div>
            {cartData?.data?.length > 0 ? (
                <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
            ) : <p className='container-fluid bg-danger w-100 p-2  mx-4 text-center text-white'>No data found</p>}
        </div >
        </>
    )
}

export default WalletCustomerList;
